import { Avatar, AvatarSkeleton } from "@src/appV2/redesign/system/ui-components";
import type { AvatarSize } from "@src/appV2/redesign/system/ui-theme";

interface WorkerAvatarProps {
  size?: AvatarSize;
  profilePictureUrl?: string;
  isLoading?: boolean;
}

export function WorkerAvatar(props: WorkerAvatarProps) {
  const { size, profilePictureUrl, isLoading } = props;

  if (isLoading) {
    return <AvatarSkeleton size={size} />;
  }

  return <Avatar src={profilePictureUrl} size={size} />;
}
